import { Injectable } from '@angular/core';

import dayjs from 'dayjs';
import { FormControl } from '@angular/forms';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import {
  BaryModalAcceptanceHowToComponent,
  BaryModalAddOrUpdateAddressComponent,
  BaryModalAddOrUpdateHeadbandComponent,
  BaryModalBrowsePdfComponent,
  BaryModalConfirmCanDeactivateComponent,
  BaryModalConfirmComponent,
  BaryModalCutOffHowToComponent,
  BaryModalFiltersComponent,
  BaryModalListErrorComponent,
  BaryModalPricingHowToComponent,
  BaryModalResultComponent,
  BaryModalSpecialDestinationHowToComponent,
} from '../app/shared/components';
import { ISpecialPlace } from '../models/special-place.model';
import { BaryComponentHelper } from '../app/shared/util/bary-component-helper';
import { PopinContactTransportComponent, SpecialPlaceCreateDialogComponent } from '../app/shared/ui';
import { AttributeFilter } from '../app/shared/ui/models/attribute-filter';
import { Transport } from '../models/transport.model';
import { BaryModalTransporterRespondQuotationComponent } from '../app/+middle/quotations/components/bary-modal-transporter-respond-quotation/bary-modal-transporter-respond-quotation.component';
import { BaryModalTransporterCancelQuotationConfirmationComponent } from '../app/+middle/quotations/components/bary-modal-transporter-cancel-quotation-confirmation/bary-modal-transporter-cancel-quotation-confirmation.component';
import { BaryModalCustomerRespondQuotationComponent } from '../app/+user/my-registered-addresses/components/bary-modal-customer-respond-quotation/bary-modal-customer-respond-quotation.component';
import { BaryProceedPaymentModalComponent } from '../app/shared/components/features/modals/bary-modal-proceed-payment/bary-modal-proceed-payment';
import { IRegisteredAddress, RegisteredAddress } from '../models/registered-address.model';
import { Headband, IHeadband } from '../models/headband.model';
import { TransportItem } from '../models/transport-item.model';
import { Subject } from 'rxjs';
import { IBaryModalEvent } from '../models/bary-modal-event';
import { ModalChangeOfferComponent } from '../app/shared/components/features/modals/modal-change-offer/modal-change-offer.component';
import { ModalChangeOrderComponent } from '../app/shared/components/features/modals/modal-change-order/modal-change-order.component';
import { InsuranceItem } from '../models/insurance-item.model';
import { ModalAddOrUpdateInsuranceItemComponent } from '../app/shared/components/features/modals/modal-add-or-update-insurance-item/modal-add-or-update-insurance-item.component';
import { InsuranceItemCategory } from '../models/insurance-item-view.model';
import { ModalAddInsuranceItemCategoryComponent } from '../app/shared/components/features/modals/modal-add-insurance-item-category/modal-add-insurance-item-category.component';
import { ICustomer } from '../models/customer.model';
import { cloneObject } from '../app/shared/util/object-util';
import { ModalCustomerUserTypologyComponent } from '../app/+middle/customer/middle-customer-detail/modal-customer-user-typology/modal-customer-user-typology.component';
import { BasketOrder } from '../models/basket-order.model';
import { ModalCustomerConfirmationDifferedPaymentComponent } from '../app/+middle/customer/middle-customer-detail/modal-customer-confirmation-differed-payment/modal-customer-confirmation-differed-payment.component';
import { ModalCustomerNotificationDifferedPaymentComponent } from '../app/+user';
import { ModalNewOfferComponent } from '../app/entities/offer/modal/modal-new-offer/modal-new-offer.component';
import { TransportFormGroup } from '../models/forms/TransportFormGroup';
import { ModalUseRegisteredAddressComponent } from '../app/+estimation/components/modal-use-registered-address/modal-use-registered-address.component';
import { BaryModalUpdateTransportConfirmComponent } from '../app/shared/components/features/modals/bary-modal-update-transport-confirm/bary-modal-update-transport-confirm.component';
import { FieldTypeEnum } from '../models/enums/field-type.enum';
import { BaryModalEditWithConfirmComponent } from '../app/shared/components/features/modals/bary-modal-edit-with-confirm/bary-modal-edit-with-confirm.component';
import { BaryModalAddTransportIncidentComponent } from '../app/shared/components/features/modals/bary-modal-add-transport-incident/bary-modal-add-transport-incident.component';
import { BaryModalConfirmDeliveryComponent } from '../app/shared/components/features/modals/bary-modal-confirm-delivery/bary-modal-confirm-delivery.component';
import { IGenericBaryFormGroup } from '../models/forms/GenericBaryFormGroup';
import { TransportExtraConditionControls } from '../models/transport-extra-condition.controls';
import { BaryModalAddOrUpdateAdrComponent } from '../app/shared/components/features/modals/bary-modal-add-or-update-adr/bary-modal-add-or-update-adr.component';
import { CarouselItem } from '../models/carousel-item.model';
import { BaryModalAddCardToCarouselComponent } from '../app/+middle/homepage/bary-modal-add-card-to-carousel/bary-modal-add-card-to-carousel.component';
import { BaryModalAddQuestionAnswerComponent } from '../app/+middle/homepage/bary-modal-add-question-answer/bary-modal-add-question-answer.component';
import { BasketOrderView } from '../models/basket-order-view.model';
import { BaryModalRefundComponent } from '../app/shared/components/features/modals/bary-modal-refund/bary-modal-refund.component';
import { BaryModalTransportRefundComponent } from '../app/shared/components/features/modals/bary-modal-transport-refund/bary-modal-transport-refund.component';
import { OfferViewDTO } from '../models/offer-view-dto.type';

import { TransportView } from '../models/transport-view.model';
import { PopinDetailTransportComponent } from '../app/shared/ui/tables/tables-list/transports-pending-list/modals/popin-detail-transport/popin-detail-transport.component';
import { PopinEvtTransportComponent } from '../app/shared/ui/tables/tables-list/transports-pending-list/modals/popin-evt-transport/popin-evt-transport.component';
import { TransportOrderView } from '../models/transport-order-view.model';

import { TRANSPORT_ITEM_ESTIMATE_STEP } from '../models/enums/transport-item-estimate-step.enum';
import { ModalEstimateComponent } from '../app/+estimation/components/modal-estimate/modal-estimate.component';
import { PaymentMethodEnum } from '../models/enums/payment-method.enum';
import { QuotationView } from '../models/quotation-view.model';

@Injectable({
  providedIn: 'root',
})
export class BaryModalService {
  private modalRef!: MDBModalRef;

  private globalOption = {
    data: {},
    animated: true,
    ignoreBackdropClick: true,
    scroll: true,
  };

  constructor(private modalService: MDBModalService) {}

  openSuccess(
    message: string,
    buttons: { first: string; second: string | undefined } = {
      first: 'Poursuivre',
      second: undefined,
    }
  ): BaryModalService {
    const data = {
      message,
      buttons,
      icon: 'check',
      class: 'text-success',
    };
    this.modalRef = this.modalService.show(BaryModalResultComponent, this.getOption(data));
    return this;
  }

  openError(
    message: string,
    buttons: { first: string; second: string | undefined } = {
      first: 'Retour',
      second: undefined,
    }
  ): BaryModalService {
    const data = {
      message,
      icon: 'times',
      class: 'text-danger',
      buttons,
    };

    this.modalRef = this.modalService.show(BaryModalResultComponent, this.getOption(data));
    return this;
  }

  openInfo(
    message: string,
    buttons: { first: string; second: string | undefined } = {
      first: 'Continuer',
      second: undefined,
    }
  ): BaryModalService {
    const data = {
      message,
      icon: 'info',
      class: 'text-info',
      buttons,
    };

    this.modalRef = this.modalService.show(BaryModalResultComponent, this.getOption(data));
    return this;
  }

  openConfirmCanDeactivate(
    message: string,
    buttons: { submit: string; second: string } = {
      second: 'Annuler',
      submit: 'Confirmer',
    },
    title?: string,
    icon?: string,
    isAlerte: boolean = false
  ): BaryModalService {
    const data = {
      message,
      buttons,
      icon,
      class: 'text-warning',
      title,
      isAlerte,
    };
    this.modalRef = this.modalService.show(BaryModalConfirmCanDeactivateComponent, this.getOption(data));
    return this;
  }

  openConfirm(
    message: string,
    buttons: { submit: string; second: string } = {
      second: 'Annuler',
      submit: 'Confirmer',
    },
    title?: string,
    icon = 'exclamation-triangle'
  ): BaryModalService {
    const data = {
      message,
      buttons,
      icon,
      class: 'text-warning',
      title,
    };
    this.modalRef = this.modalService.show(BaryModalConfirmComponent, this.getOption(data));
    return this;
  }

  openConfirmWithMail(
    message: string,
    buttons: { submit: string; second: string } = {
      second: 'Envoyer ultérieurement',
      submit: 'Envoyer maintenant !',
    }
  ): BaryModalService {
    const data = {
      message,
      buttons,
      icon: 'exclamation-triangle',
      class: 'text-warning',
    };
    this.modalRef = this.modalService.show(BaryModalConfirmComponent, this.getOption(data));
    return this;
  }

  openListError(
    title: string,
    errors: string[],
    buttons: { first: string; second: string | undefined } = {
      first: 'Retour',
      second: undefined,
    }
  ): BaryModalService {
    const data = {
      title,
      errors,
      icon: 'times',
      class: 'text-danger',
      buttons,
    };

    this.modalRef = this.modalService.show(BaryModalListErrorComponent, this.getOption(data, { class: 'modal-lg' }));
    return this;
  }

  openSpecialPlace(model: ISpecialPlace): BaryModalService {
    const data = {
      model: BaryComponentHelper.copy(model),
    };
    this.modalRef = this.modalService.show(SpecialPlaceCreateDialogComponent, this.getOption(data, { class: 'modal-lg' }));
    return this;
  }

  openFilters(attributeFilters: AttributeFilter[], filters: {}): BaryModalService {
    attributeFilters.forEach(s => (s.label += ' '));
    const data = {
      options: attributeFilters,
      filters,
    };
    this.modalRef = this.modalService.show(BaryModalFiltersComponent, this.getOption(data, { class: 'modal-lg modal-dialog-scrollable' }));
    return this;
  }

  openTransporterQuotationRespond(quotation: QuotationView): BaryModalService {
    const data = {
      quotation,
    };
    this.modalRef = this.modalService.show(BaryModalTransporterRespondQuotationComponent, this.getOption(data, { class: 'modal-xl modal-dialog-scrollable' }));
    return this;
  }

  openTransporterQuotationCanceledConfirmation(): BaryModalService {
    this.modalRef = this.modalService.show(BaryModalTransporterCancelQuotationConfirmationComponent, this.getOption(undefined, { class: 'modal-lg' }));
    return this;
  }

  openCustomerQuotationRespond(quotation: QuotationView): BaryModalService {
    const data = {
      quotation,
    };
    this.modalRef = this.modalService.show(BaryModalCustomerRespondQuotationComponent, this.getOption(data, { class: 'modal-lg modal-dialog-scrollable' }));
    return this;
  }

  openConfirmPayment(message: string, params: any, userTypology: PaymentMethodEnum, hasSepaAlias: boolean): BaryModalService {
    const data = {
      message,
      params,
      hasSepaAlias,
      userTypology,
    };
    this.modalRef = this.modalService.show(BaryProceedPaymentModalComponent, this.getOption(data));
    return this;
  }

  openAddOrUpdateAddress(model: IRegisteredAddress = new RegisteredAddress()): BaryModalService {
    const data = { model };
    const option = { class: 'modal-lg', scroll: true };
    this.modalRef = this.modalService.show(BaryModalAddOrUpdateAddressComponent, this.getOption(data, option));
    return this;
  }

  openAddOrUpdateHeadband(model?: IHeadband): BaryModalService {
    if (!model) {
      model = new Headband();
      model.startDate = new Date();
      model.endDate = dayjs().add(7, 'day').toDate();
    }
    const data = { model };
    const option = { class: 'modal-lg', scroll: true };
    this.modalRef = this.modalService.show(BaryModalAddOrUpdateHeadbandComponent, this.getOption(data, option));
    return this;
  }

  action(): Subject<IBaryModalEvent> {
    return this.modalRef.content.action as Subject<IBaryModalEvent>;
  }

  private getOption(data: any = {}, otherOptions: any = {}): any {
    return { ...BaryComponentHelper.copy(this.globalOption), data, ...otherOptions };
  }

  public openChangeOffer(transport: Transport): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-xl';
    option.scroll = true;
    option.data = { transport };
    this.modalRef = this.modalService.show(ModalChangeOfferComponent, option);
    return this;
  }

  public openChangeOrderModal(labelField = 'id', items?: any[]): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.scroll = true;
    option.data = { model: items, labelField };
    this.modalRef = this.modalService.show(ModalChangeOrderComponent, option);
    return this;
  }

  public openAddOrUpdateInsuranceItem(model?: InsuranceItem, itemsNatureList: string[] = []): BaryModalService {
    const type = model ? 'update' : 'create';
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { model: model ?? new InsuranceItem(), type, itemsNatureList };
    this.modalRef = this.modalService.show(ModalAddOrUpdateInsuranceItemComponent, option);
    return this;
  }

  public openAddInsuranceItemCategory(model?: InsuranceItemCategory): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { model: model ?? new InsuranceItemCategory() };
    this.modalRef = this.modalService.show(ModalAddInsuranceItemCategoryComponent, option);
    return this;
  }

  public openUserPaymentTypology(userTypology: PaymentMethodEnum, customer?: ICustomer): BaryModalService {
    const option = this.getOption();
    option.data = { customer: cloneObject(customer), type: userTypology };
    this.modalRef = this.modalService.show(ModalCustomerUserTypologyComponent, option);
    return this;
  }

  public openUserConfirmationDifferedPayment(userTypology: PaymentMethodEnum, customer?: ICustomer, basketOrders?: BasketOrder[]): BaryModalService {
    const option = this.getOption();
    option.data = { customer: cloneObject(customer), type: userTypology, basketOrderList: basketOrders };
    this.modalRef = this.modalService.show(ModalCustomerConfirmationDifferedPaymentComponent, option);
    return this;
  }

  public openUserNotificationDifferedPayment(userTypology: PaymentMethodEnum, customer?: ICustomer, basketOrders?: BasketOrder[]): BaryModalService {
    const option = this.getOption();
    option.data = { customer: cloneObject(customer), type: userTypology, basketOrderList: basketOrders };
    this.modalRef = this.modalService.show(ModalCustomerNotificationDifferedPaymentComponent, option);
    return this;
  }

  public openNewOffer(): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    this.modalRef = this.modalService.show(ModalNewOfferComponent, option);
    return this;
  }

  public openUseRegisteredAddress(transportForm: TransportFormGroup, isPickup: boolean, isLightEstimate = false): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { transportForm, isPickup, isLightEstimate };
    this.modalRef = this.modalService.show(ModalUseRegisteredAddressComponent, option);
    return this;
  }

  public openTransportUpdateConfirm(
    message: string,
    buttons: { submit: string; second: string } = {
      second: 'Annuler',
      submit: 'Confirmer',
    }
  ): BaryModalService {
    const data = {
      message,
      buttons,
      icon: 'exclamation-triangle',
      class: 'text-warning',
    };
    this.modalRef = this.modalService.show(BaryModalUpdateTransportConfirmComponent, this.getOption(data));
    return this;
  }

  public openEditWithConfirm(d: {
    label: string;
    messageFn: (...args: any[]) => any;
    fieldType: FieldTypeEnum;
    control?: FormControl;
    value?: any;
    fieldOptions?: any;
    staticMessage?: string;
    isModification?: boolean;
    enableSubmitBtn?: boolean;
  }): BaryModalService {
    const data = {
      icon: 'exclamation-triangle',
      class: 'text-warning',
      ...d,
    };
    this.modalRef = this.modalService.show(BaryModalEditWithConfirmComponent, this.getOption(data));
    return this;
  }

  public openAddTransportIncident(transporterId: number, transportOrderId: number): BaryModalService {
    const data = { transporterId, transportOrderId };
    const option = { class: 'modal-lg' };
    this.modalRef = this.modalService.show(BaryModalAddTransportIncidentComponent, this.getOption(data, option));
    return this;
  }

  public openConfirmDelivery(transportOrderId: number): BaryModalService {
    const data = { transportOrderId };
    const option = { class: 'modal-lg' };
    this.modalRef = this.modalService.show(BaryModalConfirmDeliveryComponent, this.getOption(data, option));
    return this;
  }

  public openModalEstimate(transportFormGroup: TransportFormGroup, currentStep: TRANSPORT_ITEM_ESTIMATE_STEP, currentTransportItem: TransportItem): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { transportFormGroup, currentStep, currentTransportItem };
    this.modalRef = this.modalService.show(ModalEstimateComponent, option);
    return this;
  }

  public openAddOrUpdateADR(
    refADRUNOptions: { label: string; value: string }[],
    transportExtraConditionForm?: IGenericBaryFormGroup<TransportExtraConditionControls>
  ): BaryModalService {
    const data = { transportExtraConditionForm, refADRUNOptions };
    const option = { class: 'modal-lg' };
    this.modalRef = this.modalService.show(BaryModalAddOrUpdateAdrComponent, this.getOption(data, option));
    return this;
  }

  public openAddCardToCarousel(model: CarouselItem | undefined, isUpdate: boolean): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { model, isUpdate };
    this.modalRef = this.modalService.show(BaryModalAddCardToCarouselComponent, option);
    return this;
  }

  public openAddQuestionAnswer(model: { question: string; answer: string }, isUpdate: boolean): BaryModalService {
    const option = this.getOption();
    option.class = 'modal-lg';
    option.data = { model, isUpdate };
    this.modalRef = this.modalService.show(BaryModalAddQuestionAnswerComponent, option);
    return this;
  }

  public openRefundListOT(basketOrder: BasketOrderView): BaryModalService {
    const data = { basketOrder };
    const option = { class: 'modal-xxl' };
    this.modalRef = this.modalService.show(BaryModalRefundComponent, this.getOption(data, option));
    return this;
  }

  public openTransportRefund(transport: TransportOrderView): BaryModalService {
    const data = { transport };
    const option = { class: 'modal-xxl' };
    this.modalRef = this.modalService.show(BaryModalTransportRefundComponent, this.getOption(data, option));
    return this;
  }

  public openHelpPricing(offer: OfferViewDTO): BaryModalService {
    const data = { offer };
    const option = { class: 'modal-xl' };
    this.modalRef = this.modalService.show(BaryModalPricingHowToComponent, this.getOption(data, option));
    return this;
  }

  public openHelpAcceptance(): BaryModalService {
    this.modalRef = this.modalService.show(BaryModalAcceptanceHowToComponent, this.getOption(undefined, { class: 'modal-xl' }));
    return this;
  }

  public openHelpCutOff(): BaryModalService {
    this.modalRef = this.modalService.show(BaryModalCutOffHowToComponent, this.getOption(undefined, { class: 'modal-xl' }));
    return this;
  }

  public openHelpSpecialDestination(): BaryModalService {
    this.modalRef = this.modalService.show(BaryModalSpecialDestinationHowToComponent, this.getOption(undefined, { class: 'modal-xl' }));
    return this;
  }

  public openBrowserPDF(blobPdf: Blob, filename: string, title: string | undefined): BaryModalService {
    const data = { blobPdf, filename, title };
    const option = { class: 'modal-xl' };
    this.modalRef = this.modalService.show(BaryModalBrowsePdfComponent, this.getOption(data, option));
    return this;
  }

  public showPopinContact(transportView: TransportView): BaryModalService {
    this.modalRef = this.modalService.show(PopinContactTransportComponent, this.getOption({ transportView }, { class: 'modal-lg' }));
    return this;
  }

  public showDetailTransport(transportView: TransportView): BaryModalService {
    this.modalRef = this.modalService.show(PopinDetailTransportComponent, this.getOption({ transportView }, { class: 'modal-xl' }));
    return this;
  }

  public showPopinEvtOnTransport(messages: string[]): BaryModalService {
    this.modalRef = this.modalService.show(PopinEvtTransportComponent, this.getOption({ messages }, { class: 'modal-lg' }));
    return this;
  }
}
